import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'

import { apiUrl } from '@/utils/config';

// 这里写的是axios请求的时候的配置
let baseUrl = apiUrl;
let _axios = axios.create({
    baseURL: baseUrl,
    timeout: '3000',
    withCredentials: true, // 设置默认请求带cookie
    crossDomain: true
});

_axios.interceptors.request.use(
    config => {
        if (config.method === 'get') {
            config.params = {
                ...config.params,
                t: new Date().getTime()
            };
        }
        return config;
    },
    err => {
        return Promise.reject(err);
    }
);

Vue.use(VueAxios, _axios)

// 邀请官网
_axios.inviteHome = (params) => {
    return Vue.axios.get('/other/inviteHome', {
        params: params,
        keep_cache: 0
    })
}

// 下载地址
_axios.inviteUrl = () => {
    return Vue.axios.get('/other/install')
}

// 安卓判断是否跳到应用商店
_axios.thirdLocate = () => {
    return Vue.axios.get('other/thirdLocate')
}

// ios判断是否登录
_axios.isLogin = () => {
    return Vue.axios.get('website/isLogin')
}
// 口令获取接口
_axios.passCodeCreate = () => {
    return Vue.axios.get('web/passCodeCreate')
}
